import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Card, DemoBadge, ConfirmDialog } from "@/components/lf";
import { useStore, fmtDate } from "@/lib/hooks";
import { write, StorageError } from "@/lib/storage";
import { rupiah } from "@/lib/catalog";
import { PLAN } from "@/lib/cart";

export default function Langganan() {
  const sub = useStore("subscription");
  const [ask, setAsk] = useState(null);

  const choose = () => {
    try {
      const start = new Date();
      const end = new Date(start); end.setFullYear(end.getFullYear() + 1);
      write("subscription", { planId: PLAN.id, planName: PLAN.name, price: PLAN.price, demo: true, startedAt: start.toISOString(), endsAt: end.toISOString() });
      toast.success("Langganan demo dipilih. Tidak ada pembayaran yang diproses.");
    } catch (e) { toast.error(e instanceof StorageError ? e.message : "Gagal menyimpan."); }
    setAsk(null);
  };

  return (
    <div>
      <PageHeader testid="page-title-langganan" overline="Akun" title="Langganan Tahunan" subtitle="Paket contoh untuk menggambarkan pengalaman berlangganan. Tidak ada penagihan, perpanjangan otomatis, atau pemrosesan pembayaran.">
        <DemoBadge>DEMONSTRASI — tanpa penagihan nyata</DemoBadge>
      </PageHeader>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        <Card className="lg:col-span-3 !p-8" data-testid="plan-card">
          <div className="lf-overline mb-3">Paket</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-none">{PLAN.name}</h2>
          <div className="mt-6 flex items-baseline gap-2"><span className="font-serif text-5xl" data-testid="plan-price">{rupiah(PLAN.price)}</span><span className="text-[#929197]">/ tahun</span></div>
          <div className="text-[10px] uppercase tracking-widest text-[#d4a95f] mt-1">Harga contoh untuk demonstrasi</div>
          <ul className="mt-8 space-y-3" data-testid="plan-benefits">
            {PLAN.benefits.map((b) => <li key={b} className="flex gap-3 text-sm leading-relaxed"><Check size={16} className="text-[#E6E2D6] mt-0.5 shrink-0" />{b}</li>)}
          </ul>
          {sub ? (
            <div className="mt-8 flex flex-wrap gap-2">
              <button disabled className="lf-btn" data-testid="plan-active-button">Paket demo aktif</button>
              <button data-testid="plan-cancel-button" onClick={() => setAsk("cancel")} className="lf-btn-ghost">Batalkan langganan demo</button>
            </div>
          ) : (
            <button data-testid="plan-select-button" onClick={() => setAsk("select")} className="lf-btn mt-8 !px-8 !py-3">Pilih paket (demo)</button>
          )}
        </Card>
        <Card className="lg:col-span-2 h-fit" data-testid="subscription-status">
          <div className="lf-overline mb-3">Status langganan</div>
          {sub ? (
            <>
              <div className="font-serif text-3xl">{sub.planName}</div>
              <p className="text-sm text-[#929197] mt-2">Dipilih {fmtDate(sub.startedAt)} · simulasi berakhir {fmtDate(sub.endsAt)}</p>
              <p className="text-xs text-[#d4a95f] mt-3">Ini hanya pilihan demonstrasi. Tidak ada penagihan atau perpanjangan.</p>
            </>
          ) : <p className="text-sm text-[#929197] leading-relaxed" data-testid="no-subscription">Anda belum memilih paket. Memilih paket di halaman ini hanya menyimpan status demo di peramban Anda.</p>}
        </Card>
      </div>

      <ConfirmDialog open={!!ask} onOpenChange={(o) => !o && setAsk(null)} testid="subscription-confirm"
        title={ask === "cancel" ? "Batalkan langganan demo?" : "Pilih paket demonstrasi?"}
        description={ask === "cancel" ? "Status langganan demo akan dihapus dari peramban ini." : `Ini hanya simulasi paket ${rupiah(PLAN.price)}/tahun. Tidak ada pembayaran yang diproses.`}
        confirmLabel={ask === "cancel" ? "Batalkan" : "Pilih paket"}
        onConfirm={ask === "cancel" ? () => { write("subscription", null); setAsk(null); toast.success("Langganan demo dibatalkan."); } : choose} />
    </div>
  );
}
